import React, { Component } from 'react';
import { connect } from 'react-redux';
import FileUpload from '../../pages/Comun/FileUpload';


class SeleccionarAdjuntoEcommerce extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }



    render() {
        const { props } = this;
        return (
            <div>
                {/* <Modal idModal='seleccionar-situacion' modalSize='modal-dialog modal-lg' title='Seleccionar Adjunto'
                       closeModal={this.props.closeModal}
                       isOpen
                > */}
                <div className='steps-container fdvNew-slides'>
                    <div className='row'>
                        <div className='col-md-6 mb-3 mt-2'>
                            <div className='form-group'>
                                <label className="labelInfo" htmlFor="TipoImagen">
                                    Tipo de imagen
                                </label>
                                <select
                                    id={`p_tipoimgEcommerceMasivo_`}
                                    name={`p_tipoimgEcommerceMasivo`}
                                    className="form-control input-sm"
                                    onChange={(e) => props.onChangeValueTipImg(e)}
                                >
                                    <option value="0">Seleccione</option>
                                    {props.arretipimag.map((c, i) => (
                                        <option key={i} value={c.codigo}>
                                            {c.descripcion}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6 mb-3 mt-2'>
                            <div className='form-group'>
                                <label className="labelInfo" htmlFor="ColorVeh">
                                    Color del Vehiculo
                                </label>
                                <select
                                    id={`p_colorVehEcommerceMasivo_`}
                                    name={`p_colorVehEcommerceMasivo`}
                                    className="form-control input-sm"
                                    onChange={(e) => props.onChangeValueColVeh(e)}
                                >
                                    <option value="0">Seleccione</option>
                                    {props.listaColorVeh.map((c, i) => (
                                        <option key={i} value={c.codPintura}>
                                            {c.color}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        {(props.listaColorVeh.find(
                            (obj) =>
                                obj.codPintura === props.ecommerceCargaMasColVeh
                        ) &&
                            props.listaColorVeh.find(
                                (obj) =>
                                    obj.codPintura === props.ecommerceCargaMasColVeh
                            )["pinturaTapizList"] &&
                            props.listaColorVeh.find(
                                (obj) =>
                                    obj.codPintura === props.ecommerceCargaMasColVeh
                            )["pinturaTapizList"].length > 0)
                            ? (
                                <div className='col-md-6 mb-3 mt-2'>
                                    <div className='form-group'>
                                        <label className="labelInfo" htmlFor="TipoImagen">
                                            Color de Tapiz
                                </label>
                                        <select
                                            id={`p_tipoimgEcommerceMasivo_`}
                                            name={`p_tipoimgEcommerceMasivo`}
                                            className="form-control input-sm"
                                            onChange={(e) => props.onChangeValueColTap(e)}
                                        >
                                            <option value="0">Seleccione</option>



                                            {props.listaColorVeh
                                                .find(
                                                    (obj) =>
                                                        obj.codPintura === props.ecommerceCargaMasColVeh
                                                )
                                            ["pinturaTapizList"].map((c, i) => (
                                                <option key={i} value={c.codColorTapiz}>
                                                    {c.desColorTapiz}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>
                            ) : (
                                <div className='col-md-6 mb-3 mt-2'>
                                    <div className='form-group'>
                                        <label className="labelInfo" htmlFor="TipoImagen">
                                            Color de Tapiz
                                            <select className="form-control input-sm">
                                                <option value="0">Seleccione</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>
                            )}

                    </div>


                    <div className='row'>
                        <FileUpload
                            onDrop={this.props.onDrop.bind(this)}
                            accept='.jpg,.png' />
                    </div>
                    <div className='modal-actions'>
                        <div align="right">
                            <button className="btn btn-orange-p" onClick={() => props.grabarEcommerceMasivo()} style={{ width: "95px" }}>
                                Guardar
				            </button>
                        </div>
                    </div>

                </div>
                {/* </Modal> */}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}


SeleccionarAdjuntoEcommerce.defaultProps = {};
export default connect(mapStateToProps,
    {})(SeleccionarAdjuntoEcommerce);



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/SeleccionaAdjuntoEcommerce.js